import {
  filtersReducer as _filtersReducer,
  initialFiltersState,
  TMainFiltersWidgetActions,
} from '@cian/valuation-main-filters-widget';

import { EActionTypes } from '../../actions/filters';
import { TReduxActions } from '../../types/redux';
import { IFiltersState } from '../../types/redux/filters';

export const initialState: IFiltersState = {
  ...initialFiltersState,
  pushEnabled: false,
};

export function filtersReducer(state: IFiltersState = initialState, action: TReduxActions): IFiltersState {
  switch (action.type) {
    case EActionTypes.SetPushEnabled:
      return {
        ...state,
        pushEnabled: action.payload,
      };

    default:
      return {
        ..._filtersReducer(state, action as TMainFiltersWidgetActions),
        pushEnabled: state.pushEnabled,
      };
  }
}
